import React from 'react'
import { DragSource } from 'react-dnd'

export class ChassisFittedOption extends React.Component {

    constructor(props) {
        super(props)
        // Bind this to element function calls for better performance / practise
        // - ref: https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/jsx-no-bind.md
        this.editClickCall = this.editClickCall.bind(this)
        this.deleteCall = this.deleteCall.bind(this)
        this.updateFittedOptionChassisNoteCall = this.updateFittedOptionChassisNoteCall.bind(this)

        // Internal states that no one else needs to know about holds info on the selection options
        this.state = {
            showEditOptions: false,
            isDeleting: false,
            customLabel: this.props.customLabel
        }
    }

    deleteCall() {
        this.setState({ isDeleting: true })
        this.props.deletedCallback(this.props.RowIndex, this.props.PoleIndex, this.props.itemId)
    }

    editClickCall() {
        this.setState({ showEditOptions: !this.state.showEditOptions }, () => {
            if (this.state.showEditOptions) this.refs.labelInput.focus()
        })
    }

    updateFittedOptionChassisNoteCall() {
        this.props.updateFittedOptionChassisNote(this.props.itemId, this.props.RowIndex, this.props.PoleIndex, this.state.customLabel)
        this.setState({ showEditOptions: false })
    }

    generateDevicePositions(startNumber) {
        const spaceUsed = parseInt(this.props.poles, 10)
        const displayNumbers = []

        for (let i = 0; i < spaceUsed; i++) {
            let displayNumber = startNumber + i
            if (displayNumber < 10) displayNumber = '0' + displayNumber

            displayNumbers.push(
                <div className="breaker-check-container" key={displayNumber}>
                    <div className="switchboard__breaker-check">{ displayNumber }</div>
                </div>
            )
        }

        return displayNumbers
    }

    render() {
        const uniqueIndex = 'p-tag-row' + this.props.RowIndex + '-' + this.props.PoleIndex

        if (this.props.isDragging) {
            return <div className="switchboard__slot" ref={ this.props.connectDragSource }></div>
        }
        
        return (
            <div className="switchboard__slot is-fitted-option" key={uniqueIndex} ref={ this.props.connectDragSource }>
                <span className="switchboard__slot-number">{ this.props.PoleIndex + 1 }</span>
                <form className={`switchboard__breaker is-${this.props.poles}-slot ${this.state.showEditOptions ? 'is-edit' : ''}`}
                    onSubmit={ (event) => { event.preventDefault(); this.updateFittedOptionChassisNoteCall(); }}>
                    <div className="switchboard__breaker-checklist">
                        { this.generateDevicePositions(this.props.PoleIndex + 1) }
                    </div>
                    <div className="switchboard__breaker-content">
                        <input className="input" type="text" ref="labelInput" maxLength="30" required value={ this.state.customLabel } onChange={ (event) => this.setState({ customLabel: event.target.value }) } />
                        <span className="switchboard__breaker-text">
                            { this.props.currentRating } <br></br>
                            { this.props.code }
                        </span>

                        {
                            this.state.customLabel !== '' && !this.state.showEditOptions &&
                            <div className="switchboard__breaker-note">
                                { this.state.customLabel }
                            </div>
                        }
                    </div>
                    <div className="switchboard__breaker-actions">
                        <div className="actions actions--default">
                            <button className={ `button button--icon edit ${this.props.itemId === 0 ? 'is-disabled' : ''}`} type="button" onClick={ this.editClickCall }>
                                <span className="i-edit"></span>
                            </button>
                            <button className={ `button button--icon delete ${this.state.isDeleting ? 'is-deleting' : ''} ${this.props.itemId === 0 ? 'is-disabled' : ''}`} type="button" onClick={ this.deleteCall } disabled={this.props.itemId === 0}>
                                <span className="i-trash-bin"></span>
                            </button>
                        </div>
                        <div className="actions actions--edit">
                            <button className="button button--icon confirm" type="button" onClick={ this.updateFittedOptionChassisNoteCall }>
                                <span className="i-check"></span>
                            </button>
                            <button className="button button--icon cancel" type="button" onClick={ this.editClickCall }>
                                <span className="i-close"></span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default DragSource('ResidentialChassisPole', 
    {
        beginDrag: (props) => {
            return {}
        },
        endDrag(props, monitor) {
            const dropResult = monitor.getDropResult() 
            
            if (dropResult) {
                props.updateFittedOptionPosition(props.itemId, dropResult.rowIndex, dropResult.poleIndex, props.customLabel)
            }
        },
        canDrag(props) {
            return props.isAllowedToDragNDropPole
        }
    }, 
    (connect, monitor) => {
        return {
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging()
        }
    }
)(ChassisFittedOption)
